<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && tender">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">
			<h5 class="mb-3">{{ tender.name }}</h5>

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<table
							class="table"
							*ngIf="tender">
							<tbody>
								<tr *ngFor="let k of stringkeys">
									<td>{{'tender.' + k | translate}}</td>
									<td>{{tender[k]}}</td>
								</tr>
								<tr *ngFor="let k of datekeys">
									<td>{{'tender.' + k.field | translate}}</td>
									<td *ngIf="k.showtime">
										{{ tender[k.field] | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
									<td *ngIf="!k.showtime">
										{{ tender[k.field] | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngFor="let k of currencykeys">
									<td>{{'tender.' + k | translate}}</td>
									<td>{{tender[k] | currency: 'EUR'}}</td>
								</tr>
								<tr *ngFor="let k of perckeys">
									<td>{{'tender.' + k | translate}}</td>
									<td>{{tender[k] | number:'1.2-2'}}%</td>
								</tr>
								<tr>
									<td>Imprese</td>
									<td>
										<span *ngFor="let k of booleankeys; let l=last">
											{{'tender.' + k | translate}}
											<span>{{l ? '' : ','}}</span>
										</span>
									</td>
								</tr>
								<tr>
									<td>Tipi di costo</td>
									<td>
										<span
											class="mr-1"
											*ngIf="tender.hrresources">
											- {{'tender.hrresources' | translate}}
										</span>
										<span
											class="mr-1"
											*ngIf="tender.tools">
											- {{'tender.tools' | translate}}
										</span>
										<span
											class="mr-1"
											*ngIf="tender.buildings">
											- {{'tender.buildings' | translate}}
										</span>
										<span
											class="mr-1"
											*ngIf="tender.othercosts">
											- {{'tender.othercosts' | translate}}
										</span>
										<span *ngIf="!tender.hrresources && !tender.tools && !tender.buildings &&!tender.othercosts">-</span>
									</td>
								</tr>
							</tbody>
						</table>

						<div *ngFor="let k of longstringkeys">
							<h6>{{'tender.' + k | translate}}</h6>
							<p [innerHTML]="tender[k]"></p>

						</div>

						<div class="row mt-1">
							<div class="col">
								<button
									(click)="edit()"
									class="btn btn-primary">
									{{'labels.edit' | translate}}
								</button>
							</div>
						</div>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="tender"
							[bootstrap]="true"
							(change)="attachmentsChanged()"
							[eid]="tender.id"></app-attachments>
					</ng-template>
				</ng-container>
				<ng-container
					*ngIf="isAdmin"
					ngbNavItem="doctemplate">
					<a
						routerLink="."
						fragment="doctemplate"
						ngbNavLink>
						Template Documenti
					</a>
					<ng-template ngbNavContent>
						<app-doctemplate-list [tenderid]="tender.id"></app-doctemplate-list>

					</ng-template>
				</ng-container>

				<ng-container ngbNavItem="demand">
					<a
						routerLink="."
						fragment="demand"
						ngbNavLink>
						Sezioni Domanda
					</a>
					<ng-template ngbNavContent>
						<app-textblock-list [tenderid]="tender.id"></app-textblock-list>

					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">{{'errors.loading.tender' | translate}}</app-card>

	</div>
</div>
